import { absolutePath } from "./absolutePath";

interface ReferralsParams {
  order?: Record<string, "asc" | "desc">;
  page?: number;
  per_page?: number;
}

export const partnerProgram = {
  get: () => absolutePath("partner_program"),
  enroll: () => absolutePath("partner_program/enroll"),
  referrals: (params: ReferralsParams = {}) =>
    absolutePath("partner_program/referrals", params),
};
